export const FILTERS_SELECT = 'filters-select';
export const FILTERS_SET_CATEGORIES= 'filters-set-categories';
export const FILTERS_TOGGLE_VISIBILITY='filters-toggle-visibility';

export function toggleVisibility(){
	return { type: FILTERS_TOGGLE_VISIBILITY };
}


export function select(payload){
	return { type: FILTERS_SELECT, payload };
}

export function setCategories(categories){
	return { type: FILTERS_SET_CATEGORIES, categories };
}


// WEBPACK FOOTER //
// ./src/redux/actions/filtersAction.jsx